import React, { useState, useEffect } from "react";
import { EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { stateToHTML } from "draft-js-export-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useMaterialUIController } from "context";
import MDBox from "components/MDBox";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import axios from "axios";
import { handleAlert } from "redux/festures/alertSlice";
import { skCompany } from "redux/festures/isCompany";
import { useDispatch } from "react-redux";
import { adminId } from "Utils/api2";

const Skeditor = ({
  editorState,
  setEditorState,
  placeholder,
  initialContent,
  content,
  isButton,
}) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const dispatch = useDispatch();
  const adminId = localStorage.getItem("admin_id");

  useEffect(() => {
    if (initialContent) {
      const blocksFromHTML = convertFromHTML(initialContent);
      const contentState = ContentState?.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      const editorState = EditorState?.createWithContent(contentState);
      setEditorState(editorState);
    }
  }, [initialContent]);
  const onChangeEditor = (state) => {
    setEditorState(state);
  };

  const convertContentToHTML = () => {
    const contentState = editorState?.getCurrentContent();
    const html = stateToHTML(contentState);
    return html;
  };

  const handleSubmitForm = async () => {
    ;
    if (!adminId) {
      dispatch(
        handleAlert({
          isOpen: true,
          type: "error",
          msg: "Admin ID not found",
        })
      );
      return;
    }

    const htmlContent = convertContentToHTML();
    ;

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_APII}/update/company/${adminId}`,
        { [content]: htmlContent },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      ;
      if (response?.data?.success) {
        dispatch(skCompany({ url: `/getCompanyByAdmin/${adminId}` }));
        dispatch(
          handleAlert({
            isOpen: true,
            type: "success",
            msg: response.data?.message || "Successfully updated your data",
          })
        );
      } else {
        dispatch(
          handleAlert({
            isOpen: true,
            type: "error",
            msg: response.data?.message || "Failed to update data",
          })
        );
      }
    } catch (error) {
      dispatch(
        handleAlert({
          isOpen: true,
          type: "error",
          msg: error.response?.data?.message || "An error occurred",
        })
      );
      
    }
  };

  const htmlContent = convertContentToHTML();

  return (
    <>
      <MDBox
        sx={({ palette: { dark, white, info } }) => ({
          backgroundColor: darkMode ? "#fff" : "#000",
          color: darkMode ? "#000" : "#fff",
          p: 0.5,
          width: "100%",
          minHeight: "70vh",
          borderRadius: "7px",
          // display: "block",
        })}
      >
        <Editor
          editorState={editorState}
          onEditorStateChange={onChangeEditor}
          placeholder={placeholder}
        />

        {/* <div>
        <h3>HTML Output:</h3>
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </div> */}
      </MDBox>
      {!isButton && (
        <MDBox
          sx={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end", my: 1.5 }}
        >
          <MDButton type="button" color="info" variant="gradient" onClick={handleSubmitForm}>
            Update
          </MDButton>
        </MDBox>
      )}
    </>
  );
};

export default Skeditor;

Skeditor.propTypes = {
  editorState: PropTypes.object,
  setEditorState: PropTypes.func,
  handleSubmitForm: PropTypes.func,
  initialContent: PropTypes.string,
  content: PropTypes.string,
  placeholder: PropTypes.string,
  isButton: PropTypes.bool,
};
